<template>
    <common-page>
        <div class="card d-flex flex-row">
            <div class="d-flex flex-column">

            </div>
        </div>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage";

export default {
    name: "StorageBinPage",
    components: {CommonPage}
}
</script>

<style scoped>

</style>